<template>
    <div class="vx-image-set">
        <!-- <view-upload v-if="viewActive" :src="viewSrc" /> -->
        <div class="con-img-upload">
            <div
                v-for="(img, index) in images"
                :class="{
                    removeItem: itemRemove.includes(index)
                }"
                :key="index"
                class="img-upload"
            >
                <button class="btn-x-file" type="button" @click="removeFile(index)">
                    <i translate="no" class="material-icons notranslate">
                        clear
                    </i>
                </button>
                <button class="btn-upload-file"></button>
                <div class="custom-center">
                    <slot></slot>
                </div>
                <img
                    :key="index"
                    :src="img"
                    class="imagePreview"
                    @touchend="$emit('clicked', index)"
                    @click="$emit('clicked', index)"
                />
            </div>
        </div>
    </div>
</template>

<script>
// import viewUpload from './viewUpload'
var lastTap = 0
export default {
    name: 'vx-image-set',
    inheritAttrs: false,
    props: {
        value: {
            type: Array,
            default: () => []
        },
        fileName: {
            default: null,
            type: String
        },
        data: {
            default: null,
            type: Object
        }
    },
    data: () => ({
        inputValue: null,
        type: null,
        srcs: [],
        filesx: [],
        itemRemove: [],
        percent: 0,
        viewActive: false,
        viewSrc: null
    }),
    watch: {
        value() {
            this.itemRemove = []
        }
    },
    computed: {
        images: {
            get() {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            }
        }
    },
    methods: {
        viewImage(src, evt) {
            var timeout
            var eventx =
                'ontouchstart' in window ||
                (window.DocumentTouch && document instanceof window.DocumentTouch)
                    ? 'touchstart'
                    : 'click'
            if (eventx == 'click') {
                this.viewActive = true
                this.viewSrc = src
            } else {
                if (evt.type == 'touchend') {
                    var currentTime = new Date().getTime()
                    var tapLength = currentTime - lastTap
                    clearTimeout(timeout)
                    if (tapLength < 500 && tapLength > 0) {
                        this.viewActive = true
                        this.viewSrc = src
                        event.preventDefault()
                    }
                    lastTap = currentTime
                }
            }
        },
        removeFile(index) {
            this.$emit('deleted', index)
        }
    }
}
</script>

<style scoped>
.btn-upload-file {
    pointer-events: none;
}
.imagePreview {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    max-width: 100%;
    max-height: 100%;
}
.custom-center {
    opacity: 0;
    transform: scale(0.6);
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    pointer-events: none;
    z-index: 1000;
}
.flex-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
}
.img-upload:hover .custom-center {
    opacity: 1;
    transform: scale(1);
}
.con-img-upload .img-upload .btn-x-file:hover ~ div {
    opacity: 0;
}
</style>
